import { bookingContainer } from './inversify.config'
import { BookingService } from './machines/booking'
import { getInitialContext } from './machines/context'
import { BookingContext } from './machines/types'
import { QuoteRequestParams } from './quote/schema'

export function getBookingService(
  requestParams: QuoteRequestParams,
  langCode: string,
) {
  const serviceFactory: (ctx: BookingContext) => BookingService =
    bookingContainer.get('Factory<BookingService>')
  const service = serviceFactory({
    ...getInitialContext(),
    requestParams,
    langCode,
  })
  return service
}
